import styled from '@emotion/styled';
import { Radio } from '@mui/material';

const StyledRadio = styled(Radio)({
  paddingTop: 2,
  paddingBottom: 2,
});

export default StyledRadio;
